export default __webpack_public_path__ + "static/media/img7.0954c852.jpg";